export const ERROR_CANT_CREATE_LINK_WO_UPGRADE = "Cannot create any more links without upgrading the account";